export const MY_ZETRIX_LOGO = 'ZETRIX'
